import styled from 'styled-components/macro'

const FooterStyle = styled.footer`
  height: 2rem;
  padding-top: 0.6rem;
  transform: translateY(-100%);
  font-size: 0.6rem;
  text-align: center;
`
export default FooterStyle
